import { Rutas } from '@/constants/rutas';
import FantasyLaLigaIcon from '../../icons/fantasy-la-liga-icon';
import PujaIdealIcon from '../../icons/puja-idea-icon';
import RachasIcon from '../../icons/rachas-icon';

export const NavigationFantasyRelevoItems = [
    {
        title: 'Mercado Fantasy',
        shortTitle: 'Mercado',
        path: Rutas.MERCADO,
        id: 'mercado',
        icon: <FantasyLaLigaIcon iconWidth={20} iconHeight={20} />,
    },
    {
        title: 'Puja Ideal',
        path: Rutas.PUJA_FANTASY,
        shortTitle: 'Puja',
        id: 'puja-fantasy',
        icon: <PujaIdealIcon iconWidth={20} iconHeight={20} />,
    },
    {
        title: 'Puntuaciones por jornada',
        path: Rutas.PUNTUACIONES_FANTASY,
        shortTitle: 'Puntos',
        id: 'puntos',
    },
    {
        title: 'Oráculo Fantasy',
        path: Rutas.ORACULO_FANTASY,
        shortTitle: 'Oráculo',
        id: 'oraculo-fantasy',
    },
    {
        title: 'Estadísticas Fantasy',
        path: Rutas.ESTADISTICAS_FANTASY_JUGADORES,
        shortTitle: 'Estadísticas',
        id: 'fantasy-la-liga-estadisticas',
    },
    {
        title: 'Mejores rachas',
        path: Rutas.MEJORES_RACHAS,
        shortTitle: 'Rachas',
        id: 'fantasy-la-liga-rachas',
        icon: <RachasIcon iconWidth={20} iconHeight={20} />,
    },
    {
        title: 'Líderes por estadísticas',
        path: Rutas.LIDERES_ESTADISTICAS,
        shortTitle: 'Líderes',
        id: 'lideres-estadisticas',
    },
    {
        title: 'Predicción de mercado',
        path: Rutas.PREDICCION_DE_MERCADO,
        shortTitle: 'Predicción',
        id: 'prediccion-mercado',
    },
    {
        title: 'Chollos fantasy Dazn',
        path: Rutas.CHOLLOS_FANTASY_RELEVO,
        shortTitle: 'Chollos',
        id: 'chollos',
    },
    /*{
        title: 'Comparador de jugadores',
        path: Rutas.COMPARADOR_DE_JUGADORES,
        shortTitle: 'Comparador',
        id: 'fantasy-la-liga-comparador',
    },*/
];
